<template>
    <div class="viewer-image">

        <div class="viewer-image-frame">

            <!-- Animated-->
            <transition v-if="animated" appear name="fade" mode="out-in">
                <img v-if="isReadable" :src="data" />
            </transition>

            <!-- Not Animated -->
            <img :src="data" />

        </div>

    </div>
</template>

<script>
import { mapGetters } from '@generio-ai/library-legacy/plugins/vuex'

export default {
    name: 'ViewerImageRaw',
    props: {
        data: {
            type: String,
            default: null
        },
        animated: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters('assets', [
            'isFileDataReadable'
        ]),
        isReadable() {
            return this.isFileDataReadable(this.data)
        }
    }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}

.viewer-image {
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
}

.viewer-image-frame {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.viewer-image-frame img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}
</style>